import State from "slotworks/state-machine/states/state";
import Logger = require("js-logger");
import ICSpinRecord from "integration/revolver/schema/spin-record";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Layers from "slotworks/graphics/layers/layers";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Point from "slotworks/utils/geom/point";
import Contract from "slotworks/utils/contract";
import { sequence, parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import Components from "slotworks/components/components";
import DSComponents from "components/components";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import graphicsManager from "slotworks/graphics/graphics-manager";
import animationManager from "slotworks/graphics/animation/animation-manager";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import { resolve } from "url";
import soundManager from "slotworks/sound/sound-manager";

export default class CoinsDrop extends State {

    public onEnter() {

        const icrecord = gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;

        const TWEEN_TIME: number = 100;
        const tweenFuncs: Array<() => Contract<void>> = [];
        let lastColumn = -1; 
        let delay = 0;
        let landingPotPositions = [0, 0, 0];
        // the array is ordered by column because of the way its created
        icrecord.underCoinSymbols.forEach((symbol, point) => {
            tweenFuncs.push(() => {                
                return new Contract<void>(resolve=>{                    
                    if(lastColumn === -1) lastColumn = point.x;
                    if(lastColumn !== point.x) {
                        lastColumn = point.x;
                        delay += 500;
                    }
                // testing     
                //    setTimeout(() => {
                    //    soundManager.customEvent("collect_coin");
                        soundManager.customEvent("collect_coin_start");
                        const matrixSymbol = Components.matrix.getSymbol(point.x, point.y);                                
                        matrixSymbol.setSymbol(symbol);
                        matrixSymbol.updateTransform();
                        icrecord.grid[matrixSymbol.gridPosition.x - 1][matrixSymbol.gridPosition.y - 1] = symbol;
                        const coinAnimation:AnimatedSprite = graphicsManager.createAnimation('COIN_win');             
                        const tweenTime = (5 - point.y + 1) * TWEEN_TIME;
                        const matrixSymbolTransform = matrixSymbol.getTransform();
                        const coinTransform = Layers.MatrixContent.localToLocal(Layers.SymbolAnimations, matrixSymbolTransform);
                        coinAnimation.anchor.set(0.5, 0.5);
                        coinAnimation.setTransform(coinTransform.x + matrixSymbolTransform.width/2, coinTransform.y);
                        coinAnimation.animationSpeed = 0.7;
                        Layers.SymbolAnimations.add(coinAnimation);                    
                        const destinationPoint = DSComponents.coinPots.getNextCoinPosition(matrixSymbol.gridPosition.x - 1, Layers.SymbolAnimations);
                        coinAnimation.play();                               
                        let tweenPoint = coinAnimation.position;                                            
                        new TweenJS.Tween(coinAnimation.scale)
                        .to({ x: [1.3, 0.38], y: [1.3, 0.38] }, tweenTime)     
                        .easing(TweenJS.Easing.Cubic.In)      
                        .interpolation(TweenJS.Interpolation.Bezier)                                              
                        .start();
                        new TweenJS.Tween(coinAnimation.position)
                        .to({ x: [tweenPoint.x, destinationPoint.x + destinationPoint.width/2], 
                            y: [tweenPoint.y - coinAnimation.height/2, destinationPoint.y + destinationPoint.height/2] }, 
                            tweenTime)
                        .interpolation(TweenJS.Interpolation.Bezier)               
                        .easing(TweenJS.Easing.Sinusoidal.In)                    
                        .onComplete(() => {
                            soundManager.customEvent("collect_coin_end");
                            coinAnimation.visible = false;
                            coinAnimation.destroy();                        
                            DSComponents.coinPots.addCoin(point.x);
                            resolve(null);                            
                        })
                        .start();
                //    }, delay);
                });
            });
            
        });
        if (tweenFuncs.length) {           
            sequence(tweenFuncs).then(() => { 
                setTimeout(() => this.complete(), 300)});                            
        } else {
            this.complete();
        }
    }

    public complete() {
        const actions = (gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord).potTriggeredFeatures;
        DSComponents.coinPots.setActions(actions);        
        super.complete();        
    }
}
